import { accountIdFormat } from "@redotech/redo-ids-cockroach";
import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-model/views/views";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getPriceBooksCount = unaryRpc({
  name: "getPriceBooksCount" as const,
  input: z.object({
    accountId: accountIdFormat.schema,
    search: z.string().nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
  }),
  output: z.object({ total: z.number() }),
});
